import { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/assettypes/Data Table";
import AssetTypeHistoryModal from "../../components/assettypes/AssetTypeHistoryModal";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import { Badge } from "react-bootstrap";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import Update_data_modal from "../../components/manageInvoice/update_data_modal/index";
import AssetDetailModal from "../../components/assettypes/Asset Details";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPenToSquare,
  faTrash,
  faEnvelope,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import Layouts from "../../layouts/layouts";

export default function AssetType() {
  const title = "Assets Type";

  const [apistate, setApiState] = useState([]); // Ensure this is an array initially
  const [apicol, setApiCol] = useState([]); // Ensure this is an array initially
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);
  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedAssetType, setSelectedAssetType] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalUsed, setTotalUsed] = useState(0);
  const [totalAvailable, setTotalAvailable] = useState(0);

  const [search, setSearch] = useState("");
  const [company, setCompany] = useState("");
  const [purchasedFrom, setPurchasedFrom] = useState("");
  const [purchaseMonth, setPurchaseMonth] = useState("");
  const filters = {
    company,
    purchasedFrom,
    purchaseMonth,
  };
  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const brad = [{ name: "Home" }, { name: title }];

  const columns = [
    {
      name: <b>Asset Name</b>,
      selector: (row) => row._id,
      sortable: true,
    },

    {
      name: <b>Amount</b>,
      selector: (row) => row.totalCost,
      sortable: true,
      cell: (row) => `₹${row.totalCost?.toLocaleString("en-IN") || 0}`,
    },

    {
      name: <b>Quantity</b>,
      selector: (row) => row.totalQuantity,
      sortable: true,
    },

    {
      name: <b>Used</b>,
      selector: (row) => row.totalUsed,
      sortable: true,
    },

    {
      name: <b>Available</b>,
      selector: (row) => row.totalAvailable,
      sortable: true,
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <button
          onClick={() => viewAssetHistory(row)}
          className="btn btn-primary btn-sm"
          title="History"
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      ),
    },
  ];

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };
  const viewAssetHistory = (row) => {
    setSelectedAssetType(row);
    setShowHistoryModal(true);
  };

  const handleApplyFilters = (newFilters) => {
    setCompany(newFilters?.company || "");
    setPurchasedFrom(newFilters?.purchasedFrom || "");
    setPurchaseMonth(newFilters?.purchaseMonth || "");

    // Always go back to first page after applying filters
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setCompany("");
    setPurchasedFrom("");
    setPurchaseMonth("");

    // Always go back to first page
    setCurrentPage(1);
  };

  const fetchData = async (page = 1, limit = rowsPerPage) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        console.error("No token found");
        return;
      }

      const params = new URLSearchParams();

      params.append("page", page);
      params.append("limit", limit);

      if (search) {
        params.append("search", search);
      }

      if (company) {
        params.append("company", company);
      }

      if (purchasedFrom) {
        params.append("purchasedFrom", purchasedFrom);
      }

      if (purchaseMonth) {
        params.append("purchaseMonth", purchaseMonth);
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/asset-types?${params.toString()}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (Array.isArray(response.data.assetTypes)) {
        setApiState(response.data.assetTypes);
      }

      setTotalCount(response.data.count || 0);
      setTotalAmount(response.data.totalAmount || 0);
      setTotalQuantity(response.data.totalQuantity || 0);
      setTotalUsed(response.data.totalUsed || 0);
      setTotalAvailable(response.data.totalAvailable || 0);

      setTotalCount(response.data.count || 0);
      setApiCol(columns);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage, rowsPerPage);
  }, [currentPage, rowsPerPage, search, company, purchasedFrom, purchaseMonth]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const copyLink = () => {
    alert(46);
  };
  const delete_row = (row) => {
    Swal.fire({
      icon: "warning",
      title: "You wont be able to revert this!",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        axios
          .delete(
            `${process.env.REACT_APP_BASE_URL}/api/v1/asset-type/${row._id}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          )
          .then(() => {
            Swal.fire("Deleted!", "Asset has been deleted.", "success");
            fetchData(currentPage);
          })
          .catch((error) => {
            Swal.fire("Error!", "Asset could not be deleted.", "error");
            console.error("Error deleting asset:", error);
          });
      }
    });
  };

  const updateAsset = (updatedAsset) => {
    setApiState((prev) =>
      prev.map((asset) =>
        asset._id === updateAsset._id ? updateAsset : asset,
      ),
    );
  };

  const handleUpdateAsset = (updatedAssetData) => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    axios
      .put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/asset-type/${updatedAssetData._id}`,
        updatedAssetData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        Swal.fire("Updated!", "Asset details have been updated.", "success");
        updateAsset(response.data.asset);
      })
      .catch((error) => {
        Swal.fire("Error!", "Asset details could not be updated.", "error");
        console.error(
          "Error updating asset:",
          error.response ? error.response.data : error.message,
        );
      });
  };

  const viewAsset = (asset) => {
    setSelectedAsset(asset);
    setShowAssetDetailModal(true);
  };

  const exportToExcel = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        console.error("No token found");

        Swal.fire("Error", "Authentication token not found.", "error");

        return;
      }

      // =====================================================
      // FETCH ALL ASSET TYPES
      // =====================================================

      const params = new URLSearchParams();

      // Fetch all records instead of current page
      params.append("page", 1);
      params.append("limit", 100000);

      // Current Search
      if (search) {
        params.append("search", search);
      }

      // Current Company Filter
      if (company) {
        params.append("company", company);
      }

      // Current Purchased From Filter
      if (purchasedFrom) {
        params.append("purchasedFrom", purchasedFrom);
      }

      // Current Purchase Month Filter
      if (purchaseMonth) {
        params.append("purchaseMonth", purchaseMonth);
      }

      // =====================================================
      // API CALL
      // =====================================================

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/asset-types?${params.toString()}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const assets = response.data.assetTypes || [];

      if (assets.length === 0) {
        Swal.fire("No Data", "No asset data available to export.", "info");

        return;
      }

      // =====================================================
      // SHEET 1 - SUMMARY
      // =====================================================

      const summaryData = assets.map((asset, index) => ({
        "S.No": index + 1,

        "Asset Name": asset.assetname || asset._id || "",

        Amount: Number(asset.totalCost || 0),

        Quantity: Number(asset.totalQuantity || 0),

        Used: Number(asset.totalUsed || 0),

        Available: Number(asset.totalAvailable || 0),
      }));

      // =====================================================
      // SHEET 2 - PURCHASE HISTORY
      // =====================================================

      const historyData = [];

      let historySerialNumber = 1;

      assets.forEach((asset) => {
        const entries = Array.isArray(asset.entries) ? asset.entries : [];

        // ---------------------------------------------------
        // Add every purchase entry of this asset
        // ---------------------------------------------------

        entries.forEach((entry) => {
          historyData.push({
            "S.No": historySerialNumber++,

            "Asset Name": entry.assetname || asset.assetname || asset._id || "",

            Cost: Number(entry.cost || 0),

            Quantity: Number(entry.quantity || 0),

            "Purchase Date": entry.purchasedDate
              ? new Date(entry.purchasedDate).toLocaleDateString("en-IN")
              : "",

            "Purchased From": entry.purchasedFrom || "",

            Company: entry.company || "",

            Description: entry.description || "",
          });
        });
      });

      // =====================================================
      // CREATE WORKBOOK
      // =====================================================

      const workbook = XLSX.utils.book_new();

      // =====================================================
      // CREATE SUMMARY SHEET
      // =====================================================

      const summaryWorksheet = XLSX.utils.json_to_sheet(summaryData);

      // =====================================================
      // CREATE HISTORY SHEET
      // =====================================================

      const historyWorksheet = XLSX.utils.json_to_sheet(historyData);

      // =====================================================
      // COLUMN WIDTHS - SUMMARY
      // =====================================================

      summaryWorksheet["!cols"] = [
        { wch: 8 }, // S.No
        { wch: 25 }, // Asset Name
        { wch: 15 }, // Amount
        { wch: 12 }, // Quantity
        { wch: 12 }, // Used
        { wch: 12 }, // Available
      ];

      // =====================================================
      // COLUMN WIDTHS - HISTORY
      // =====================================================

      historyWorksheet["!cols"] = [
        { wch: 8 }, // S.No
        { wch: 25 }, // Asset Name
        { wch: 15 }, // Cost
        { wch: 12 }, // Quantity
        { wch: 18 }, // Purchase Date
        { wch: 25 }, // Purchased From
        { wch: 20 }, // Company
        { wch: 40 }, // Description
      ];

      // =====================================================
      // ADD SHEETS TO WORKBOOK
      // =====================================================

      XLSX.utils.book_append_sheet(workbook, summaryWorksheet, "Summary");

      XLSX.utils.book_append_sheet(
        workbook,
        historyWorksheet,
        "Purchase History",
      );

      // =====================================================
      // DOWNLOAD EXCEL
      // =====================================================

      const fileName = `Asset_Types_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;

      XLSX.writeFile(workbook, fileName);

      // =====================================================
      // SUCCESS MESSAGE
      // =====================================================

      Swal.fire({
        icon: "success",
        title: "Export Successful",
        text: `${assets.length} asset types and ${historyData.length} purchase history records exported.`,
        timer: 1800,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error(
        "Error exporting asset types:",
        error.response?.data || error,
      );

      Swal.fire("Error", "Unable to export asset data.", "error");
    }
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />

      <AssetDetailModal
        show={showAssetDetailModal}
        onHide={() => setShowAssetDetailModal(false)}
        asset={selectedAsset}
      />
      <AssetTypeHistoryModal
        show={showHistoryModal}
        onHide={() => setShowHistoryModal(false)}
        assetType={selectedAssetType}
      />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              {/* <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <Link to="/create_assettype">
                  <div className="btn btn-info btn-sm text-white">
                    Asset Type
                  </div>
                </Link>
              </div> */}
              <div
                className="card-header bg-white d-flex align-items-center justify-content-between flex-wrap"
                style={{
                  padding: "10px 16px",
                  borderBottom: "1px solid #dee2e6",
                  gap: "10px",
                }}
              >
                {/* LEFT SIDE - TITLE + SUMMARY */}
                <div
                  className="d-flex align-items-center flex-wrap"
                  style={{ gap: "6px" }}
                >
                  {/* TITLE */}
                  <h5
                    className="mb-0 me-2"
                    style={{
                      fontWeight: "400",
                      color: "#343a40",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Assets Type
                  </h5>

                  {/* TOTAL ASSET TYPES */}
                  <div
                    className="d-flex align-items-center px-3 py-2"
                    style={{
                      background: "#f5f3ff",
                      border: "1px solid #d8d0ff",
                      borderRadius: "8px",
                      minWidth: "125px",
                      height: "40px",
                    }}
                  >
                    <span
                      className="me-2"
                      style={{
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        background: "#e8e3ff",
                        color: "#4723d9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      A
                    </span>

                    <span
                      style={{
                        color: "#555",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Asset Types
                    </span>

                    <strong
                      className="ms-2"
                      style={{
                        color: "#4723d9",
                        fontSize: "14px",
                      }}
                    >
                      {totalCount}
                    </strong>
                  </div>

                  {/* TOTAL AMOUNT */}
                  <div
                    className="d-flex align-items-center px-3 py-2"
                    style={{
                      background: "#eef7ff",
                      border: "1px solid #cfe5f8",
                      borderRadius: "8px",
                      minWidth: "135px",
                      height: "40px",
                    }}
                  >
                    <span
                      className="me-2"
                      style={{
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        background: "#dceeff",
                        color: "#0878d1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      ₹
                    </span>

                    <span
                      style={{
                        color: "#555",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Amount
                    </span>

                    <strong
                      className="ms-2"
                      style={{
                        color: "#0878d1",
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      ₹{Number(totalAmount || 0).toLocaleString("en-IN")}
                    </strong>
                  </div>

                  {/* TOTAL QUANTITY */}
                  <div
                    className="d-flex align-items-center px-3 py-2"
                    style={{
                      background: "#effaf2",
                      border: "1px solid #d4ebda",
                      borderRadius: "8px",
                      minWidth: "125px",
                      height: "40px",
                    }}
                  >
                    <span
                      className="me-2"
                      style={{
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        background: "#dff3e4",
                        color: "#218838",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      Q
                    </span>

                    <span
                      style={{
                        color: "#555",
                        fontSize: "13px",
                      }}
                    >
                      Quantity
                    </span>

                    <strong
                      className="ms-2"
                      style={{
                        color: "#218838",
                        fontSize: "14px",
                      }}
                    >
                      {totalQuantity}
                    </strong>
                  </div>

                  {/* USED */}
                  <div
                    className="d-flex align-items-center px-3 py-2"
                    style={{
                      background: "#fff9e8",
                      border: "1px solid #f3dfaa",
                      borderRadius: "8px",
                      minWidth: "95px",
                      height: "40px",
                    }}
                  >
                    <span
                      className="me-2"
                      style={{
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        background: "#fff0c7",
                        color: "#a15c00",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      U
                    </span>

                    <span
                      style={{
                        color: "#555",
                        fontSize: "13px",
                      }}
                    >
                      Used
                    </span>

                    <strong
                      className="ms-2"
                      style={{
                        color: "#a15c00",
                        fontSize: "14px",
                      }}
                    >
                      {totalUsed}
                    </strong>
                  </div>

                  {/* AVAILABLE */}
                  <div
                    className="d-flex align-items-center px-3 py-2"
                    style={{
                      background: "#eefbf2",
                      border: "1px solid #ccebd5",
                      borderRadius: "8px",
                      minWidth: "115px",
                      height: "40px",
                    }}
                  >
                    <span
                      className="me-2"
                      style={{
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        background: "#dff3e4",
                        color: "#198754",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      ✓
                    </span>

                    <span
                      style={{
                        color: "#555",
                        fontSize: "13px",
                      }}
                    >
                      Available
                    </span>

                    <strong
                      className="ms-2"
                      style={{
                        color: "#198754",
                        fontSize: "14px",
                      }}
                    >
                      {totalAvailable}
                    </strong>
                  </div>
                </div>
                {/* RIGHT SIDE - ACTION */}
                <div className="d-flex align-items-center gap-2">
                  {/* Export To Excel */}
                  <button
                    type="button"
                    className="btn btn-success btn-sm text-white px-3"
                    onClick={exportToExcel}
                    style={{
                      borderRadius: "5px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Export To Excel
                  </button>

                  {/* Add Asset Type */}
                  <Link to="/create_assettype" className="text-decoration-none">
                    <button
                      type="button"
                      className="btn btn-info btn-sm text-white px-3"
                      style={{
                        borderRadius: "5px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Add Asset Type
                    </button>
                  </Link>
                </div>
              </div>

              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    // searchBy="assetname"
                    // apidata={apistate}
                    // columns={apicol}
                    // totalRows={totalCount}
                    // currentPage={currentPage}
                    // setCurrentPage={setCurrentPage}
                    // rowsPerPage={rowsPerPage}
                    // setRowsPerPage={setRowsPerPage}
                    // dataFilter={search}
                    // setDataFilter={setSearch}
                    // company={company}
                    // setCompany={setCompany}
                    // purchasedFrom={purchasedFrom}
                    // setPurchasedFrom={setPurchasedFrom}
                    // purchaseMonth={purchaseMonth}
                    // setPurchaseMonth={setPurchaseMonth}
                    apidata={apistate}
                    columns={apicol}
                    // Search
                    search={search}
                    setSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                    // Filters
                    filters={filters}
                    onApplyFilters={handleApplyFilters}
                    onClearFilters={handleClearFilters}
                    // Pagination
                    currentPage={currentPage}
                    totalRows={totalCount}
                    rowsPerPage={rowsPerPage}
                    onChangePage={(page) => {
                      setCurrentPage(page);
                    }}
                    onChangeRowsPerPage={(newPerPage) => {
                      setRowsPerPage(newPerPage);
                      setCurrentPage(1);
                    }}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
